import React from "react";
import "react-toastify/dist/ReactToastify.min.css";
import { Icon } from "assets/Icon";
import { cn } from "utils/helpers";

// Visual config per severity. `success`/`error` are unchanged from the original
// two-variant behaviour; `warning` (yellow + triangle) is additive.
const TOAST_VARIANTS = {
	success: {
		border: "!border-blue-600",
		background: "bg-blue-700",
		icon: "toast-success",
		defaultTitle: "Success",
	},
	error: {
		border: "!border-red-600",
		background: "bg-red-600",
		icon: "toast-error",
		defaultTitle: "Error",
	},
	warning: {
		border: "!border-amber-500",
		background: "bg-amber-500",
		icon: "alert-triangle",
		defaultTitle: "Warning",
	},
};

// Resolve the variant, staying backward compatible with the legacy `success`
// boolean: when no explicit `variant` is passed, true -> success, else error.
const resolveVariant = (variant, success) => {
	if (variant && TOAST_VARIANTS[variant]) {
		return variant;
	}

	return success === true ? "success" : "error";
};

export const CustomToastV2 = ({
	success,
	variant,
	closeToast,
	title,
	subtitle,
}) => {
	const resolvedVariant = resolveVariant(variant, success);
	const config = TOAST_VARIANTS[resolvedVariant];

	return (
		<div
			className={cn(
				"z-50 flex h-max justify-between gap-3 !rounded-md !border-2 bg-white p-4 pl-2 text-white shadow-md",
				config.border,
				config.background
			)}
		>
			<div className="flex gap-3">
				<Icon
					icon={config.icon}
					className="-mt-2"
					iconClassName="text-white"
				/>
				<div>
					<div className={cn("font-roboto text-lg font-semibold")}>
						{title || config.defaultTitle}
					</div>
					{subtitle && (
						<div className="font-roboto text-sm font-normal">{subtitle}</div>
					)}
				</div>
			</div>

			<div>
				<Icon
					icon="toast-close"
					className="cursor-pointer"
					onClick={closeToast}
					data-testid="toast-close-button"
				/>
			</div>
		</div>
	);
};
